import { render, staticRenderFns } from "./ServiceCenterResult.vue?vue&type=template&id=c28b5d16&scoped=true"
import script from "./ServiceCenterResult.vue?vue&type=script&lang=js"
export * from "./ServiceCenterResult.vue?vue&type=script&lang=js"
import style0 from "./ServiceCenterResult.vue?vue&type=style&index=0&id=c28b5d16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28b5d16",
  null
  
)

export default component.exports